var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6956 0.99981L32.9999 10.8515V29.1477L17.6956 38.9997L0.999904 29.1126V10.8571L17.6956 0.99981Z",
    fill: "#FEFEFE",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9662 0.579385L17.707 0.412473L17.4414 0.569252L0.745699 10.4265L0.499904 10.5716V10.8571V29.1126V29.3976L0.745131 29.5429L17.4408 39.4299L17.7066 39.5872L17.9663 39.4201L33.2706 29.5682L33.4999 29.4205V29.1477V10.8515V10.5787L33.2706 10.431L17.9662 0.579385Z",
    stroke: "#FEFEFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4999 12.9995C12.3581 12.9995 9 16.3574 9 20.4997C9 24.6414 12.3581 27.9996 16.4999 27.9996C20.6417 27.9996 23.9999 24.6414 23.9999 20.4997C23.9999 16.3574 20.6417 12.9995 16.4999 12.9995ZM21.4904 16.3392C22.3325 17.3487 22.8732 18.6174 22.9772 20.0081C22.4489 19.9514 21.9369 19.925 21.4416 19.925C20.3273 19.925 19.3 20.0589 18.3586 20.2805C18.1686 19.854 17.9762 19.4433 17.7834 19.0497C19.0272 18.4329 20.2915 17.5612 21.4904 16.3392ZM20.7147 15.5565C19.5992 16.6937 18.4318 17.5009 17.2848 18.0685C16.3109 16.2204 15.3991 14.8544 14.9333 14.1938C15.4357 14.0691 15.9601 14.0023 16.4999 14.0023C18.1091 14.0023 19.5797 14.5874 20.7147 15.5565ZM13.8488 14.5686C13.8683 14.5949 13.8887 14.6241 13.9137 14.6578C14.2972 15.1898 15.2483 16.5753 16.2731 18.5115C14.6018 19.1533 13.026 19.329 11.7909 19.331C11.1169 19.3318 10.5494 19.2782 10.1295 19.2201C10.5456 17.1373 11.958 15.415 13.8488 14.5686ZM10.008 20.3153C10.4675 20.3776 11.0753 20.4323 11.7909 20.4326C11.7982 20.4326 11.8062 20.4326 11.8136 20.4326C13.1691 20.4326 14.922 20.2277 16.775 19.4966C16.9464 19.8456 17.1178 20.2072 17.2865 20.5822C15.7961 21.0702 14.5607 21.7692 13.5933 22.4682C12.5397 23.2296 11.7982 23.9862 11.3669 24.4792C10.5129 23.3795 10.0031 21.9991 10.0031 20.4997C10.0031 20.4374 10.006 20.3767 10.008 20.3153ZM12.1169 25.2944C12.524 24.818 13.3419 23.9601 14.5504 23.142C15.4127 22.5586 16.4728 21.9963 17.7247 21.5979C18.3292 23.0645 18.8732 24.6844 19.2448 26.3885C18.4107 26.7781 17.4811 26.9965 16.4999 26.9965C14.8106 26.9965 13.2726 26.3517 12.1169 25.2944ZM20.2427 25.809C19.8693 24.208 19.3586 22.6931 18.7966 21.3096C19.6085 21.1328 20.4894 21.0275 21.4416 21.0275C21.9313 21.0275 22.44 21.0564 22.9675 21.1157C22.7848 23.0544 21.7506 24.7439 20.2427 25.809Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_288",
    x: 0,
    y: -0.174805,
    width: 36,
    height: 43.8496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_288",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNetwork);
export default __webpack_public_path__ + "static/media/socialNetwork.f9bbd804cfdc765a698e437af177dc46.svg";
export { ForwardRef as ReactComponent };